"use client";

import { c as _c } from "react/compiler-runtime";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import type { CicStatement } from "@/entities/IProfile";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import UserPageIdentityDeleteStatementModal from "./UserPageIdentityDeleteStatementModal";
export default function UserPageIdentityDeleteStatementButton(t0) {
  const $ = _c(23);
  const {
    statement,
    profile
  } = t0;
  const [isDeleteStatementOpen, setIsDeleteStatementOpen] = useState(false);
  const [isTouchScreen, setIsTouchScreen] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsTouchScreen(window.matchMedia("(pointer: coarse)").matches);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const tooltipId = `delete-statement-${statement.statement_group}-${statement.statement_type}`;
  const showTooltip = !isTouchScreen && !isDeleteStatementOpen;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsDeleteStatementOpen(true);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== showTooltip || $[4] !== tooltipId) {
    t4 = showTooltip ? {
      "data-tooltip-id": tooltipId
    } : null;
    $[3] = showTooltip;
    $[4] = tooltipId;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `${isTouchScreen ? "tw-opacity-100" : "tw-opacity-0 group-hover:tw-opacity-100"} tw-p-1.5 tw-bg-transparent tw-cursor-pointer tw-text-xs tw-font-semibold tw-text-rose-500 desktop-hover:hover:tw-text-rose-400 tw-border-0 focus:tw-outline-none tw-transition tw-duration-300 tw-ease-out`;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className="tw-flex-shrink-0 tw-w-5 tw-h-5 tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-scale-110" viewBox="0 0 24 24" aria-hidden="true" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><span className="tw-sr-only">Delete statement</span></svg>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4 || $[8] !== t5) {
    t7 = <button onClick={t3} type="button" aria-label="Delete statement" {...t4} className={t5}>{t6}</button>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== showTooltip || $[11] !== tooltipId) {
    t8 = showTooltip && <Tooltip id={tooltipId} place="top" positionStrategy="fixed" offset={8} opacity={1} style={TOOLTIP_STYLES}><span className="tw-text-xs">Delete</span></Tooltip>;
    $[10] = showTooltip;
    $[11] = tooltipId;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== isDeleteStatementOpen || $[14] !== profile || $[15] !== statement) {
    t9 = isDeleteStatementOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-10" elementRole="dialog" onClicked={_temp}><UserPageIdentityDeleteStatementModal statement={statement} profile={profile} onClose={() => setIsDeleteStatementOpen(false)} /></CommonAnimationOpacity>;
    $[13] = isDeleteStatementOpen;
    $[14] = profile;
    $[15] = statement;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t9) {
    t10 = <CommonAnimationWrapper mode="sync" initial={true}>{t9}</CommonAnimationWrapper>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t7 || $[21] !== t8) {
    t11 = <div>{t7}{t8}{t10}</div>;
    $[19] = t10;
    $[20] = t7;
    $[21] = t8;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}
function _temp(e) {
  return e.stopPropagation();
}